import React from 'react'
import styled from 'styled-components'

const Content = styled.div`
    position: absolute;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
`

const PageNotFound = () => {
    return (
        <Content>
            <h1>{'404 Page not found'}</h1>
        </Content>
    )
}

export default PageNotFound
